import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const PrepSettingsTab = () => {
  const { meta } = useAuth();
  const [sel, setSel] = useState(null);
  useEffect(() => { api.get("/settings/preparation").then((r) => setSel(r.data.service_types)); }, []);
  if (!sel) return null;
  const save = async () => {
    try { await api.put("/settings/preparation", { service_types: sel }); toast.success("Criterio de preparación guardado"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="max-w-xl space-y-4" data-testid="prep-settings-tab">
      <p className="text-sm text-muted-foreground">Tipos de servicio cuyas OS por Proyecto requieren preparación por defecto. Las OS sin proyecto inician como "No requerida" y se pueden marcar manualmente. Nunca bloquea la OS.</p>
      <div className="grid gap-2 sm:grid-cols-2">
        {(meta?.service_types || []).map((s) => (
          <label key={s.code} className="flex items-center gap-2 text-sm">
            <Checkbox checked={sel.includes(s.code)} onCheckedChange={(c) => setSel(c ? [...sel, s.code] : sel.filter((x) => x !== s.code))} data-testid={`prep-st-${s.code}`} />{s.name}
          </label>
        ))}
      </div>
      <Button onClick={save} data-testid="prep-settings-save">Guardar</Button>
    </div>
  );
};
